/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);

// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss';

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import ECharts from 'vue-echarts';
import 'echarts';

Vue.component('v-chart', ECharts);

const messages = {
  defaultLabels: {
    Consultor: 'Consultor',
    consultor: 'consultor',
    CONSULTOR: 'CONSULTOR',
    'Grupos de Veículos': 'Grupos de Veículos',
    'Grupo do Veículo': 'Grupo do Veículo',
    'grupo do veículo': 'grupo do veículo',
  },
  default123: {
    Consultor: 'Corretor',
    consultor: 'corretor',
    CONSULTOR: 'CORRETOR',
    'Produtos Obrigatórios': 'Coberturas Sugeridas',
    'Produtos Opcionais': 'Coberturas Opcionais',
    Regional: 'Corretora',
    regional: 'corretora',
    REGIONAL: 'CORRETORA',
    Regionais: 'Corretoras',
    Divisão: 'Assessoria',
    divisão: 'assessoria',
    DIVISÃO: 'ASSESSORIA',
    divisao: 'assessoria',
    'Grupos de Veículos': 'Pacotes de Coberturas',
    'Grupo do Veículo': 'Pacote de Cobertura',
    'grupo do veículo': 'pacote de cobertura',
  },
  default126: {
    Consultor: 'Corretor',
    consultor: 'corretor',
    CONSULTOR: 'CORRETOR',
    'Produtos Obrigatórios': 'Coberturas Sugeridas',
    'Produtos Opcionais': 'Coberturas Opcionais',
    Regional: 'Corretora',
    regional: 'corretora',
    REGIONAL: 'CORRETORA',
    Regionais: 'Corretoras',
    Divisão: 'Assessoria',
    divisão: 'assessoria',
    DIVISÃO: 'ASSESSORIA',
    divisao: 'assessoria',
    'Grupos de Veículos': 'Pacotes de Coberturas',
    'Grupo do Veículo': 'Pacote de Cobertura',
    'grupo do veículo': 'pacote de cobertura',
  },
  default128: {
    Consultor: 'Corretor',
    consultor: 'corretor',
    CONSULTOR: 'CORRETOR',
    'Produtos Obrigatórios': 'Coberturas Sugeridas',
    'Produtos Opcionais': 'Coberturas Opcionais',
    Regional: 'Corretora',
    regional: 'corretora',
    REGIONAL: 'CORRETORA',
    Regionais: 'Corretoras',
    Divisão: 'Assessoria',
    divisão: 'assessoria',
    DIVISÃO: 'ASSESSORIA',
    divisao: 'assessoria',
    'Grupos de Veículos': 'Pacotes de Coberturas',
    'Grupo do Veículo': 'Pacote de Cobertura',
    'grupo do veículo': 'pacote de cobertura',
  },
};
const i18n = new VueI18n({
  locale: 'defaultLabels',
  messages,
});

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';

// Vuesax Admin Filters
import './filters/filters';

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

//import * as VueGoogleMaps from 'vue2-google-maps'
//Vue.use(VueGoogleMaps, {
// load: {
// Add your API key here
//  key: 'AIzaSyA2w0PY7eaKb3OeXu1v6gbhaN1JUKNAiJs',
// libraries: 'places', // This is required if you use the Auto complete plug-in
//},
//})

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// FlatPickr (Datetime picker)
import 'flatpickr/dist/flatpickr.css';

// Feather font icon
require('./assets/css/iconfont.css');

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors',
});

import VueMask from 'v-mask';
Vue.use(VueMask);

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);
import formatDate from './utils/pipe/formatDate';
Vue.use(formatDate);

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo);

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

import VueKonva from 'vue-konva';
Vue.use(VueKonva);

//#region Permissionamento
import { abilitiesPlugin } from '@casl/vue';
import ability from './services/ability';
Vue.use(abilitiesPlugin, ability.getPermission(), {
  useGlobalProperties: true,
});

Vue.prototype.$actionsDefault = ability.actionsDefault;

//#endregion

//#region Service Status Notification

// REMOVIDO TEMPORARIAMENTE

// import serviceStatusNotification from './services/statusNotification';
// serviceStatusNotification.start();

//#endregion

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
